import { render } from "./AddEditLabel.vue?vue&type=template&id=6d8c4d04"
import script from "./AddEditLabel.vue?vue&type=script&lang=js"
export * from "./AddEditLabel.vue?vue&type=script&lang=js"

import "./AddEditLabel.vue?vue&type=style&index=0&id=6d8c4d04&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__